import React from 'react';

interface UrlPreviewSettingsProps {
  showUrlPreview: boolean;
  setShowUrlPreview: (value: boolean) => void;
  previewUrl: string;
  setPreviewUrl: (value: string) => void;
  idPrefix: string;
}

export const UrlPreviewSettings: React.FC<UrlPreviewSettingsProps> = ({
  showUrlPreview,
  setShowUrlPreview,
  previewUrl,
  setPreviewUrl,
  idPrefix
}) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id={`${idPrefix}-url-preview-toggle`}
            checked={showUrlPreview}
            onChange={(e) => {
              // URLプレビュートグル変更
              setShowUrlPreview(e.target.checked);
            }}
            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
          />
          <label htmlFor={`${idPrefix}-url-preview-toggle`} className="text-sm text-gray-700">
            URLプレビュー
          </label>
        </div>
        
        {showUrlPreview && (
          <div className="flex-1">
            <input
              type="url"
              value={previewUrl}
              onChange={(e) => {
                console.log('カスタムURL入力変更:', e.target.value);
                setPreviewUrl(e.target.value);
              }}
              placeholder="https://example.com"
              className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>
        )}
      </div>
      
      {showUrlPreview && (
        <p className="text-xs text-amber-600 bg-amber-50 px-2 py-1 rounded border border-amber-200">
          ⚠️ 一部のサイトはセキュリティ設定によりプレビューできない場合があります。
        </p>
      )}
    </div>
  );
};